import React from 'react';

export default function SalaryProcessEmptyState({ onResetFilters, onProcessSalary }) {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-6 bg-[#3ea2f5] text-white p-8 sm:p-10 rounded-xl shadow-xs my-2 select-none">
      {/* 3D Mascot / Badge */}
      <div className="relative flex items-center justify-center shrink-0">
        <div className="w-20 h-24 bg-white/20 backdrop-blur-xs rounded-2xl flex flex-col items-center justify-center p-2 border border-white/40 shadow-md transform -rotate-2">
          <div className="w-10 h-10 rounded-full bg-white text-[#3ea2f5] flex items-center justify-center mb-1 shadow-xs">
            <span className="material-symbols-outlined text-2xl font-bold">person_search</span>
          </div>
          <div className="bg-red-500 text-white font-black text-[9px] px-1.5 py-0.5 rounded text-center tracking-tight leading-tight uppercase">
            No Record Found!
          </div>
        </div>
      </div>

      {/* Main Text Message */}
      <div className="text-center sm:text-left max-w-xl">
        <h3 className="text-xl sm:text-2xl font-black tracking-tight text-white mb-1.5 font-display">
          No entries meet selected criteria
        </h3>
        <p className="text-xs sm:text-sm text-white/90 font-medium leading-relaxed">
          Either there are no entries in the selected module or you have selected invalid filter conditions.
        </p>

        {/* Action shortcut buttons */}
        <div className="mt-4 flex flex-wrap items-center justify-center sm:justify-start gap-3">
          {onProcessSalary && (
            <button
              type="button"
              onClick={onProcessSalary}
              className="px-4 py-2 bg-white text-[#0047ab] hover:bg-white/90 text-xs font-bold rounded-xl shadow-sm transition flex items-center gap-1.5 cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">settings_suggest</span>
              <span>Process Salary Now</span>
            </button>
          )}
          {onResetFilters && (
            <button
              type="button"
              onClick={onResetFilters}
              className="px-4 py-2 bg-white/15 hover:bg-white/25 text-white text-xs font-bold rounded-xl transition cursor-pointer"
            >
              Reset Filters
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
